import type { ReactNode } from "react";
import { Icon } from "../../components/Icon";

/**
 * Split-screen frame shared by every signed-out screen (sign in, forgot /
 * reset password, accept invite): the form on the left, a brand panel on
 * the right that drops away on narrow viewports. Purely presentational —
 * each screen keeps its own form and API calls.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="auth">
      <main className="auth__main">
        <div className="auth__form">{children}</div>
      </main>
      <aside className="auth__brand" aria-hidden="true">
        <div className="auth__brand-inner">
          <span className="brand-mark brand-mark--lg">
            <Icon name="phone" size={28} />
          </span>
          <p className="auth__brand-title">Utility Voice IVR</p>
          <p className="auth__brand-tagline">Design call flows, run campaigns and review every call in one place.</p>
        </div>
      </aside>
    </div>
  );
}
